/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable camelcase */
/* eslint-disable no-use-before-define */
import moment from 'moment';
import i18n from 'i18next';
import { format, addDays, parseISO } from 'date-fns';

import { routerActions } from 'connected-react-router';
import {
  TypeMerchant,
  UnitPerPage,
  USER_PISMO,
  TYPE_MOVEMENT_AUTHORIZATION,
  getStatus,
  getMethod,
} from '@constants/transactions';
import * as transactionsService from '@services/transactions-service';
import { showError } from '@store/logged/actions';
import { TRANSACTION_DETAIL } from '@constants/routes';
import { getFetchRefundsDateRange, generateCsvAndDownload, getInstallments } from '@helpers/utils';
import { formatDate } from '@helpers/date';
import { moneyFormat } from '@helpers/locale';
import { getEnv } from '@config';

import { sellerTypes } from '@hooks/useAuth';
import * as transactionTypes from './actionTypes';

export const setMovements = (movements) => ({
  type: transactionTypes.SET_MOVEMENTS,
  payload: movements,
});

export const setLastMovementsError = (error) => ({
  type: transactionTypes.SET_LAST_MOVEMENTS_ERROR,
  payload: {
    error,
    errorLastMovements: true,
  },
});

export const fetchMovements = (data) => (dispatch) =>
  transactionsService
    .getMovements(data)
    .then((response) => {
      dispatch(
        setMovements({
          ...response,
          items: response.items?.filter(
            (fil) =>
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_IN_ADVANCEMENTS ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.TED_CASH_OUT ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.CARGO_SALDO ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.CARGO_SALDO_REGULARIZADO ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.INGRESO_DE_SALDO ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.EGRESO_DE_SALDO ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.CANCEL_EGRESO_DE_SALDO ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.CANCEL_INGRESO_DE_SALDO ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.PAGO_DE_CUOTA_DE_CREDITO ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.CANCELACION_DE_PAGO ||
              fil.authorization.type === TYPE_MOVEMENT_AUTHORIZATION.CANCEL_CARGO_SALDO
          ),
        })
      );
    })
    .catch((error) => {
      dispatch(setLastMovementsError(error));
    });

export const setTransactionsData = (data) => ({
  type: transactionTypes.SET_TRANSACTION_DATA,
  payload: { data },
});

export const setRefundsTransactionsData = (dataRefunds) => ({
  type: transactionTypes.SET_REFUNDS_TRANSACTION_DATA,
  payload: { dataRefunds },
});

export const setOriginalTransactionSaleAmount = (originalTransactionSaleAmount) => ({
  type: transactionTypes.SET_ORIGINAL_TRANSACTION_SALE_AMOUNT,
  payload: { originalTransactionSaleAmount },
});

// FIXME: Evaluar cambiar el nombre a algo mas descriptivo: Propuesta: setInitialPagination o resetPagination.
// Ver que ya hay un acion `resetPagination`. Tal vez no sea necesario tener dos actions separados y pueda resumirse en una sola
export const initialPagination = () => ({
  type: transactionTypes.INITIAL_PAGINATION,
});

export const setPagination = ({ currentPage, pageTotal, perPage, itemsTotal }) => ({
  type: transactionTypes.SET_PAGINATION,
  payload: { currentPage, pageTotal, perPage, itemsTotal },
});

export const changePagination = (newPagination) => (dispatch, getState) => {
  const {
    transactions: { pagination },
  } = getState();
  dispatch(setPagination({ ...pagination, ...newPagination }));

  return dispatch(fetchTransactions());
};

export const setMerchantType = (merchantType) => ({
  type: transactionTypes.SET_MERCHANT_TYPE,
  payload: { merchantType },
});

export const setFilter = ({ startDate, endDate, text, filterApply }) => ({
  type: transactionTypes.SET_FILTER,
  payload: { startDate, endDate, text, filterApply },
});

export const resetFilter = () => ({
  type: transactionTypes.RESET_FILTER,
});

export const resetPagination = () => (dispatch) => {
  dispatch(initialPagination());
  dispatch(setTransactionsData([]));
  return dispatch(fetchTransactions());
};

// FIXME: Evaluar cambiar nombre a algo mas descriptivo: Propuesta: setDefaultDate o resetDate.
// FIXME: deprecar este action en favor de `resetFilter`. Parecería que este action setea la "fecha default". Que debería ser lo mismo que setear el "filtro default".
export const defaultDate = (date) => ({
  type: transactionTypes.DEFAULT_FILTER,
  payload: date,
});

export const changeFilter = (newFilter) => (dispatch, getState) => {
  const {
    transactions: { filter },
  } = getState();

  dispatch(setFilter({ ...filter, ...newFilter }));
};

export const setTransactionsError = (error) => ({
  type: transactionTypes.SET_TRANSACTIONS_ERROR,
  payload: {
    error,
    errorTransactions: true,
  },
});

export const fetchTransactions = () => (dispatch, getState) => {
  const {
    login: { merchant: loginMerchant },
    transactions: {
      pagination: { currentPage: page, perPage },
      filter: { startDate, endDate, text },
    },
  } = getState();

  const { transactionsFilterCodeAdvancements } = getEnv();
  const isSeller = loginMerchant.seller !== sellerTypes.ON_US;

  const query = {
    page,
    perPage,
  };

  if (isSeller) {
    query.orgOperationId = transactionsFilterCodeAdvancements;
  }

  if (text) {
    query.saleAuthorizationId = text;
  }

  if (startDate && endDate) {
    query.startEventDate = moment(startDate).format('yyyy-MM-DD');
    query.endEventDate = moment(endDate).format('yyyy-MM-DD');
  }

  const queryString = new URLSearchParams(JSON.parse(JSON.stringify(query))).toString();

  dispatch(showLoadingTransactions());

  const merchantId =
    loginMerchant.seller === 'gsc'
      ? loginMerchant.sellers[0]?.merchant_id
      : loginMerchant.wallet_info?.merchant_id;

  return merchantId
    ? transactionsService
        .getTransactions({ merchantId, query: queryString })
        .then(({ items, current_page, pages, per_page, total_items }) => {
          dispatch(setTransactionsData(items));
          dispatch(
            setPagination({
              currentPage: current_page,
              pageTotal: pages,
              perPage: per_page,
              itemsTotal: total_items,
            })
          );
        })
        .catch((error) => {
          // dispatch(showError(error))
          dispatch(setTransactionsError(error));
        })
        .finally(() => dispatch(hideLoadingTransactions()))
    : dispatch(hideLoadingTransactions());
};

// FIXME: Evaluar cambiar el nombre a algo mas descriptivo: Propuesta fetchTransactionsForMobileOnDemand
export const moreTransactions = () => (dispatch, getState) => {
  const {
    transactions: { isLoadingTransactions, data: transactions },
  } = getState();
  if (!isLoadingTransactions) {
    dispatch(changePagination({ currentPage: 1, perPage: transactions.length + UnitPerPage }));
  }
};

export const setCurrentTransaction = (data) => (dispatch) => {
  dispatch({
    type: transactionTypes.SET_CURRENT_TRANSACTION,
    payload: data,
  });
};

/**
 * Fetch from bff all refund's transactions for a specific `saleAuthorizationId`.
 * The list of refunds will be store in `redux`.
 */
export const fetchRefunds = (saleAuthorizationId, eventDate) => (dispatch, getState) => {
  dispatch(showLoading());

  // FIXME: esta mierda está repetida en todos lados. Hagamos algun helper o algo..
  const {
    login: {
      merchant: {
        // eslint-disable-next-line camelcase
        wallet_info,
      },
    },
  } = getState();
  const { merchant_id: merchantId } = wallet_info;

  const query = new URLSearchParams({
    saleAuthorizationId,
    fetchAll: true,
    perPage: 300,
    ...getFetchRefundsDateRange(eventDate),
  }).toString();
  return transactionsService
    .getTransactions({ merchantId, query })
    .then(({ items }) => {
      let originalTransactionSaleAmount = 0;
      const refunds = [];
      items.forEach((item) => {
        if (item.type === 'SALES') {
          originalTransactionSaleAmount += item.gross_value;
        } else {
          refunds.push(item);
        }
      });
      dispatch(
        setOriginalTransactionSaleAmount(Math.round(originalTransactionSaleAmount * 100) / 100)
      );
      dispatch(setRefundsTransactionsData(refunds));
      dispatch(routerActions.push(TRANSACTION_DETAIL));
    })
    .catch((error) => {
      dispatch(showError(error));
    })
    .finally(() => dispatch(hideLoading()));
};

// FIXME: Evaluar cambiar el nombre a algo mas descriptivo (El "Current" confunde): Propuesta: fetchRefund.
// Lo que hace esta funcion es obtener informacion adicional de una devolucion a partir de un objeto "transaccion".
// Propuesta de param: no hace falta recibir un objeto, con recibir solo un autorizationId alcanza.
export const fetchCurrentRefund = (transaction) => (dispatch) => {
  const { authorization_id } = transaction;
  dispatch(showLoading());
  transactionsService
    .getRefundDetail(authorization_id)
    .then((response) => {
      const { user } = response;
      // FIXME: welcome to the pismo-refund hack:
      // This response has the correct `user` for the cancelation.
      // But... has incorrect values in `transaction_original.number_of_instalments`:
      // No matter if the original transactions is in 1 or more installments it ALWAYS has value equals to 1.
      // So we have to call another bff-service to get this right.
      dispatch(fetchCurrentRefundTransaction(transaction, user, { perPage: 100 }));
    })
    .catch((error) => {
      dispatch({
        type: transactionTypes.SET_CURRENT_TRANSACTION,
        payload: {},
      });
      dispatch({
        type: transactionTypes.SET_CURRENT_REFUND,
        payload: {},
      });
      // If the refund doesn't exist in our server, we have to find it directly in Pismo using another bff.
      // eslint-disable-next-line eqeqeq
      if (error?.status == 404) {
        dispatch(fetchCurrentRefundTransaction(transaction, undefined, { perPage: 100 }));
        return;
      }
      dispatch(showError(error));
      dispatch(hideLoading());
    });
};

// FIXME: evaluar cambiar el nombre a algo mas descriptivo: Propuesta: fetchRefundFallback.
// Esta funcion lo que hace es una llamada alterativa a otro bff para obtener la información de una devolucion especifica.
// Propuesta params: Evaluar si hace falta recibir un currentRefund o si se puede obtener la misma información desde el response del bff que se está invocando dentro de la funcion.
export const fetchCurrentRefundTransaction =
  (currentRefund, user = USER_PISMO, queryParam = {}) =>
  (dispatch, getState) => {
    const {
      login: {
        merchant: {
          // eslint-disable-next-line camelcase
          wallet_info,
        },
      },
    } = getState();

    const { merchant_id: merchantId } = wallet_info;

    const query = new URLSearchParams({
      saleAuthorizationId: currentRefund.sale_authorization_id,
      fetchAll: true,
      ...queryParam,
    }).toString();
    return transactionsService
      .getTransactions({ merchantId, query })
      .then(({ items }) => {
        // If the original sales has more than one installment this only returns the data of the first installment
        // The flow was modified (in RefundCard.js) to calculate the total gross_value based one one installment info.
        const firstInstallment = items.find(
          (item) => item.authorization_id === currentRefund.sale_authorization_id
        );
        const originalTransactionTotalAmount = items.reduce(
          (acc, current) => (current.type === 'SALES' ? acc + current.gross_value : acc),
          0
        );
        // Create an object compatible with the refund's attribute: trasactionOriginal
        const transactionOriginal = {
          event_date: firstInstallment.event_date,
          authorization_id: firstInstallment.authorization_id,
          type: firstInstallment.type,
          operation: firstInstallment.operation,
          number_of_installments: firstInstallment.number_of_installments,
          gross_value: firstInstallment.gross_value,
          total: originalTransactionTotalAmount,
        };

        const transactionInfo = firstInstallment.transaction_info || {};

        // Get only the refunds associated with currentRefund
        // (this is usefull when having sales with many instalments)
        const refunds = items.filter(
          ({ type, authorization_id }) =>
            type.toUpperCase() !== 'SALES' && authorization_id === currentRefund.authorization_id
        );
        dispatch(setCurrentRefund(refunds, user, transactionOriginal, transactionInfo));
      })
      .catch((error) => {
        dispatch(showError(error));
      })
      .finally(() => dispatch(hideLoading()));
  };

export const setCurrentRefund = (data, user, transactionOriginal, transactionInfo) => ({
  type: transactionTypes.SET_CURRENT_REFUND,
  payload: {
    data,
    user,
    transactionOriginal,
    transactionInfo,
  },
});

export const showLoadingTransactions = () => ({
  type: transactionTypes.SHOW_LOADING_TRANSACTIONS,
});

export const hideLoadingTransactions = () => ({
  type: transactionTypes.HIDE_LOADING_TRANSACTIONS,
});

export const showLoadingExport = () => ({
  type: transactionTypes.SHOW_LOADING_EXPORT,
});

export const hideLoadingExport = () => ({
  type: transactionTypes.HIDE_LOADING_EXPORT,
});

export const showLoading = () => ({
  type: transactionTypes.SHOW_LOADING_CURRENT_TRANSACTION,
});

export const hideLoading = () => ({
  type: transactionTypes.HIDE_LOADING_CURRENT_TRANSACTION,
});

const EXPORT_PER_PAGE = 100;

export const exportTransactionsCsv = () => (dispatch, getState) => {
  dispatch(showLoadingExport());

  const {
    login: { merchant: loginMerchant },
    transactions: {
      filter: { startDate, endDate, text },
    },
  } = getState();

  const { transactionsFilterCodeAdvancements, showPaymentDateColumn, country } = getEnv();
  const isSeller = loginMerchant.seller !== sellerTypes.ON_US;
  const isPaymentDateColumnEnabled = showPaymentDateColumn === 'true';

  const buildQuery = (page) => {
    const query = { page, perPage: EXPORT_PER_PAGE };
    if (isSeller) {
      query.orgOperationId = transactionsFilterCodeAdvancements;
      if (text) query.authorizationId = text;
    }
    if (!isSeller && text) query.saleAuthorizationId = text;
    if (startDate && endDate) {
      query.startEventDate = moment(startDate).format('yyyy-MM-DD');
      query.endEventDate = moment(endDate).format('yyyy-MM-DD');
    }
    return new URLSearchParams(JSON.parse(JSON.stringify(query))).toString();
  };

  const merchantId =
    loginMerchant.seller === 'gsc'
      ? loginMerchant.sellers[0]?.merchant_id
      : loginMerchant.wallet_info?.merchant_id;

  if (!merchantId) {
    dispatch(hideLoadingExport());
    return Promise.resolve();
  }

  return transactionsService
    .getTransactions({ merchantId, query: buildQuery(1) })
    .then(({ items, pages }) => {
      if (pages <= 1) return items;
      const remainingPages = Array.from({ length: pages - 1 }, (_, i) =>
        transactionsService.getTransactions({ merchantId, query: buildQuery(i + 2) })
      );
      return Promise.all(remainingPages).then((results) =>
        results.reduce((acc, { items: pageItems }) => acc.concat(pageItems), items)
      );
    })
    .then((allItems) => {
      const formatAmount = (item) =>
        item.gross_value && item.gross_value >= 0
          ? `+${moneyFormat(item.gross_value)}`
          : moneyFormat(item.gross_value);

      let headers;
      let rows;

      if (isSeller) {
        headers = [
          i18n.t('transactionsFalabella.authCode'),
          i18n.t('transactionsFalabella.refNumberComplete'),
          i18n.t('transactionsFalabella.scheduledDate'),
          ...(isPaymentDateColumnEnabled ? [i18n.t('transactionsFalabella.paymentDate')] : []),
          i18n.t('transactionsFalabella.mountGrossValue'),
        ];
        rows = allItems.map((item) => [
          item.authorization_id,
          item.details_transaction?.reference_number ?? '',
          formatDate(item?.event_date, 'DD-MM-YYYY | HH:mm', false, 'UTC', country) || '-',
          ...(isPaymentDateColumnEnabled
            ? [item.payment_date ? format(addDays(parseISO(item.payment_date), 1), 'dd-MM-yyyy') : '-']
            : []),
          formatAmount(item),
        ]);
      } else {
        headers = [
          i18n.t('transactionsFalabella.operationType'),
          i18n.t('transactionsFalabella.authCode'),
          i18n.t('transactionsFalabella.payMethod'),
          i18n.t('transactionsFalabella.quotes'),
          i18n.t('transactionsFalabella.dateHour'),
          i18n.t('transactionsFalabella.mountGrossValue'),
        ];
        rows = allItems.map((item) => [
          getStatus(item.type),
          item.authorization_id,
          getMethod(item.operation),
          item.number_of_installments === 1
            ? String(item.installment ?? 1)
            : `${item.installment} de ${item.number_of_installments}`,
          formatDate(item?.event_date, 'DD-MM-YYYY | HH:mm', false, 'UTC', country) || '-',
          formatAmount(item),
        ]);
      }

      generateCsvAndDownload(headers, rows, `transactions-${moment().format('YYYY-MM-DD')}.csv`);
    })
    .catch((error) => dispatch(showError(error)))
    .finally(() => dispatch(hideLoadingExport()));
};

export const setTransactionDetails = (details) => ({
  type: transactionTypes.SET_TRANSACTION_DETAILS,
  payload: details,
});

export const setTransactionDetailsError = (error) => ({
  type: transactionTypes.SET_ERROR_TRANSACTION_DETAILS,
  payload: {
    error,
  },
});

export const clearTransactionDetails = () => ({
  type: transactionTypes.CLEAR_TRANSACTION_DETAILS,
});

export const showLoadingTransactionsDetails = () => ({
  type: transactionTypes.SHOW_LOADING_TRANSACTION_DETAILS,
});

export const hideLoadingTransactionsDetails = () => ({
  type: transactionTypes.HIDE_LOADING_TRANSACTION_DETAILS,
});

export const setTransactionReference = (transactionReference) => ({
  type: transactionTypes.SET_TRANSACTION_REFERENCE,
  payload: transactionReference,
});

export const fetchTransactionsDetails =
  (referenceID, page = 1, pageSize = 5) =>
  (dispatch, getState) => {
    const {
      login: {
        merchant: { tenant, seller_id },
      },
    } = getState();

    const payload = {
      reference_id: referenceID,
      tenant,
      page_index: page,
      page_size: pageSize,
      seller_id,
    };
    dispatch(showLoadingTransactionsDetails());
    transactionsService
      .getTransactionsDetails(payload)
      .then((res) => {
        if (res.data.pagination.total === 0) {
          dispatch(setTransactionDetailsError('error'));
        }
        dispatch(setTransactionDetails({ ...res, transactionReference: referenceID }));
        dispatch(hideLoadingTransactionsDetails());
      })
      .catch((error) => {
        dispatch(setTransactionDetailsError(error));
        dispatch(hideLoadingTransactionsDetails());
      });
  };

export const setTransactionInProgress = (transactionInProgress) => ({
  type: transactionTypes.TRANSACTION_IN_PROGRESS,
  payload: transactionInProgress,
});
